/**
 * The Nhost session cookie name, shared by the browser client (lib/nhost.ts), the server client
 * (lib/nhost-server.ts), and the edge proxy (proxy.ts). Kept in its own side-effect-free module so
 * the edge/middleware can import it WITHOUT pulling the browser SDK (which touches `document`) into
 * the edge runtime bundle.
 *
 * Value matches the SDK's DEFAULT_SESSION_KEY so nothing else needs reconfiguring.
 */
export const SESSION_COOKIE = 'nhostSession'
